import { ObservationService } from '../../../shared/observation/observation.service';
import { CommitteeMemberSearchDto } from 'src/app/committees/shared/dto/committee-member-search.dto';
import { CommitteesByRelatedProfileSearchDto } from '../../../committees/shared/dto/committees-by-related-profile-search.dto';
import { PagedResult } from '../../../shared/model/generic-paged-result.model';
import { PagedSearch } from '../../../shared/model/paged-search.model';
import { PagedResultGeneric } from 'src/app/shared';
import { CommitteeMemberService } from 'src/app/committees/shared/committee-member.service';
import { Component, OnInit, Input, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { CommitteeService } from 'src/app/committees/shared/committee.service';
import { CommitteeMemberDto } from 'src/app/committees/shared/dto/committee-member.dto';
import { CommitteeDto } from 'src/app/committees/shared/dto/committee.dto';
import { CommitteeSearchDto } from 'src/app/committees/shared/dto/committee-search.dto';
import { ProfileAddToCommitteeComponent } from '../profile-add-to-committee/profile-add-to-committee.component';
import { SecurityElementNames } from 'src/app/shared/auth/constants/security-element-names.service';

@Component({
  selector: 'wl-profile-view-committees',
  templateUrl: './profile-view-committees.component.html',
  styleUrls: ['./profile-view-committees.component.less'],
    standalone: false
})
export class ProfileViewCommitteesComponent implements OnInit {
  @ViewChild(ProfileAddToCommitteeComponent) addDialog: ProfileAddToCommitteeComponent;
  @Input() profileId: number;
  @Input() profileIsOrg: boolean;
  public committees: PagedResultGeneric<CommitteeDto>;
  public showPaging: boolean;
  public search: CommitteesByRelatedProfileSearchDto;

  constructor(
    public securityElementNames: SecurityElementNames,
    private _committeeMemberService: CommitteeMemberService,
    private _committeeService: CommitteeService,
    private _observationService: ObservationService,
    private ref: ElementRef
  ) {
    this.committees = new PagedResult();
    this.search = new CommitteesByRelatedProfileSearchDto();
    this.search.IncludeInactive = false;
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.profileId || changes.profileIsOrg) {
      if (this.profileId && this.profileIsOrg != null) {
        this.search.ProfileId = this.profileId;
        this.loadCommittees(1, true);

        this._observationService.observeProfiles().subscribe((id) => {
          if (id === this.profileId) {
            this.loadCommittees(1, true);
          }
        });
      }
    }
  }

  public loadCommittees(page: number, isInitialLoad: boolean) {
    this.search.PageSize = 5;
    this.search.PageNumber = page;

    if (this.profileIsOrg) {
      this._committeeMemberService.committeesByRelatedProfileMembers(this.search).then((data: PagedResultGeneric<CommitteeDto>) => {
        this.committees = data;

        this.committees.Result.forEach((committee) => {
          // if it's marked active, check that we have any active members and deactivate for display if none are found.
          if (committee.Active) {
            committee.Active = committee.CommitteeMembers.filter((x) => x.Active).length > 0;
          }
        });
        this.showPaging = this.committees.TotalPages > 1;

        if (!isInitialLoad) {
          const element = this.ref.nativeElement;
          window.scrollTo(window.scrollX, element.offsetTop + 50);
        }
      });
    } else {
      const indSearch = new CommitteeMemberSearchDto();
      indSearch.ProfileIds = [this.profileId];
      indSearch.IncludeInactive = this.search.IncludeInactive;
      this._committeeMemberService.search(indSearch).then((data: PagedResultGeneric<CommitteeMemberDto>) => {
        const uniqueCommittees = [...new Set(data.Result.map((x) => x.CommitteeID))];
        if (uniqueCommittees.length > 0) {
          const commSearchDto = new CommitteeSearchDto();
          commSearchDto.CommitteeIds = uniqueCommittees;
          commSearchDto.IncludeInactive = indSearch.IncludeInactive;
          commSearchDto.PageSize = this.search.PageSize;
          commSearchDto.PageNumber = page;
          commSearchDto.OrderBy = 'CommitteeID:ASC';
          this._committeeService.search(commSearchDto).then((committees: PagedResultGeneric<CommitteeDto>) => {
            this.committees = committees;
            this.showPaging = this.committees.TotalPages > 1;
            committees.Result.forEach((x) => {
              x.CommitteeMembers = data.Result.filter((y) => y.CommitteeID === x.CommitteeID);
              if (!x.Active || x.CommitteeMembers.findIndex((z) => z.Active) < 0) {
                x.Active = false;
              }
            });
          });
        } else {
          this.committees = new PagedResult();
        }
      });
    }
  }

  public onPagingEvent(page: number) {
    this.loadCommittees(page, false);
  }

  public showAddDialog() {
    this.addDialog.openDialog(this.profileId);
  }
}
